export const MAX_HISTORY_LENGTH = 10;
export const SEARCH_FAQ_HISTORY = 'search_faq';
